import { render, staticRenderFns } from "./SentMailToRepresentante.vue?vue&type=template&id=1a53d766&"
import script from "./SentMailToRepresentante.vue?vue&type=script&lang=js&"
export * from "./SentMailToRepresentante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports